import {Action} from "@ngrx/store";
import {IActivity} from '../../activities/activity';
import {IWebsiteActivitiesState} from '../reducers/activities.reducer';

export const LOAD_ACTIVITIES: string = '[activities] Load Activities';
export const LOAD_ACTIVITIES_SUCCESS: string = '[activities] Load Activities Success';
export const LOAD_ACTIVITIES_FAIL: string = '[activities] Load Activities Fail';
export const INIT_ACTIVITIES_SOCKET: string = '[activities] Init Activities Socket';

export const ADD_ACTIVITY: string = '[activities] Add Activity';

export class LoadActivities implements Action {

  readonly type: string = LOAD_ACTIVITIES;

}

export class LoadActivitiesSuccess implements Action {

  readonly type: string = LOAD_ACTIVITIES_SUCCESS;
  constructor(public payload: {
    [websiteId: number]: IWebsiteActivitiesState
  }) {}

}

export class LoadActivitiesFail implements Action {

  readonly type: string = LOAD_ACTIVITIES_FAIL;
  constructor(public payload: string) {}

}

export class InitActivitiesSocket implements Action {

  readonly type: string = INIT_ACTIVITIES_SOCKET;

}

export class AddActivity implements Action {

  readonly type: string = ADD_ACTIVITY;
  constructor(public payload: IActivity) {}

}

export type ActivitiesAction = LoadActivities | LoadActivitiesSuccess | LoadActivitiesFail | AddActivity;
